import axios from 'axios';

const backofficeAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKOFFICE_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

backofficeAxiosInstance.interceptors.request.use(
  (config) => {
    // Normalize url if baseURL already ends with /api and config.url starts with /api/
    if (config.baseURL?.endsWith('/api') && config.url?.startsWith('/api/')) {
      config.url = config.url.replace(/^\/api/, '');
    }

    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const RCN = localStorage.getItem('RCN');
    if (RCN) {
      config.headers['x-rcn'] = RCN;
    }
    
    // For development: log the request details
    // console.log('API Request:', {
    //   url: config.url,
    //   method: config.method,
    //   headers: config.headers,
    //   baseURL: config.baseURL
    // });
    
    return config;
  },
  (error) => {
    // console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

backofficeAxiosInstance.interceptors.response.use(
  (response) => {
    // Log successful responses for debugging
    // console.log('API Response:', {
    //   url: response.config.url,
    //   status: response.status,
    //   data: response.data
    // });
    return response;
  },
  (error) => {
    // console.error('API Error:', {
    //   url: error.config?.url,
    //   status: error.response?.status,
    //   message: error.message,
    //   response: error.response?.data
    // });
    
    if (error.response?.status === 401) {
    //   localStorage.removeItem('authToken');
    //   window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default backofficeAxiosInstance;
